import React, { useEffect, useState } from 'react';
import Carousel from '../Carousel/Carousel';
import UltimasNoticias from '../UltimasNoticias/UltimasNoticias';
import './inicio.css';
import { titular } from '../../json/titular';
import {  carouselImages } from '../../json/carouselImages';
import { Link } from 'react-router-dom';
//import Modal from '../Modal/Modal';//{overlay?<Modal hijoAPadre={hijoAPadre}/>:null} 
import Modal from '../Modal/ModalMulti';//{overlay?<Modal hijoAPadre={hijoAPadre}/>:null} 
//import ModalConvocatoria from '../Modal/ModalConvocatoria';//<ModalConvocatoria isOpen={isModalOpen} onClose={closeModal} />

const Inicio = () => {
  const [overlay, setOverlay] = useState(true);
  const [isModalOpen, setModalOpen] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const closeModal =()=>{
      setModalOpen(false);
  };

  let hijoAPadre = (datosHijo) => {
    setOverlay(datosHijo);
}

  return (
    <>
   {overlay?<Modal hijoAPadre={hijoAPadre}/>:null} 
      <Carousel bannerData={carouselImages} search={true} name={"banner-principal"}/>
      <div className='container'>
        <div className='row'>
          <div className='col-12'>  
          <div className='secretaria_logo' >
            <div className='secretaria_logo_img' style={{ backgroundImage: `url("https://cdn.hidalgo.gob.mx/gobierno/images/iconosSec/Seguridad.svg")` }}>

            </div>
          </div>
          <div className='secretaria_name'>
            <h1>SECRETARÍA DE SEGURIDAD PÚBLICA</h1>
          </div>
          <div className='secretaria_funciones'>
            <h3 className='title'>FUNCIONES</h3>
            <hr className='hr-gob'/>
            <p>La Secretaría de Seguridad Pública, como Dependencia del Poder Ejecutivo del Estado de Hidalgo, tiene a su cargo el ejercicio de las atribuciones y el despacho de los asuntos que le confiere la Constitución Política del Estado de Hidalgo, la Ley Orgánica de la Administración Pública para el Estado de Hidalgo, la Ley de Seguridad Pública para el Estado de Hidalgo, y otras Leyes, Reglamentos y normatividad aplicable, así como el Plan Estatal de Desarrollo 2022-2028.
              La seguridad pública es una de las funciones más sensibles a cargo del Estado, para cumplir con los objetivos de Seguridad Pública la Secretaría, se constituye como una Institución Policial de carácter civil, disciplinado y profesional, cuyo fin es asegurar el pleno goce de los derechos humanos y garantías constitucionales, el orden público, la paz, la tranquilidad y la integridad de las personas, mediante la prevención general y especial de las faltas administrativas, así como la prevención de los delitos, la sanción de las faltas administrativas, la investigación de los delitos, la persecución de los imputados, así como la administración y operación del Sistema Penitenciario, mediante la reinserción social de los delincuentes y la aplicación de la justicia para adolescentes en conflicto con la Ley. </p>
              <div className='btn_organigrama'>
                <button type="button" className="btn btn-primary"><a href='/Transparencia/Rubros/DetalleRubro/Estructura'>Organigrama</a></button>
                <button type="button" className="btn btn-primary"><a href='/Transparencia/Rubros/DetalleRubro/Normatividad'>Normatividad</a></button>
              </div>
              <div className='secretaria-redes'>
                <a href='https://www.facebook.com/SeguridadPublicaHGO'><i class="fa-brands fa-facebook-f"></i></a>
                <a href='https://twitter.com/SSP_Hidalgo'><i class="fa-brands fa-twitter"></i></a>
              </div>
          </div>
        </div>
        <UltimasNoticias/>
        <div className='row'>
          <div className='notes_title'>
            <h3 className='title'>TITULAR DE LA SECRETARÍA</h3>
            <hr className='hr-gob'/>
          </div>
          <div className='section_notes'>
            {
              titular.map((item, index) =>(
                  <>
                    <div key={ index } className='sec_photo'>
                      <div className='img_secretario' style={{ backgroundImage: `url("${ item.imagen }")` }}>
                      </div>
                    </div>
                    <div className='sec_container'>
                      <div className='sec_name'>
                        <h3>{ item.nombre }</h3>
                      </div>
                      <div className='sec_function'>
                        <h4>Función del Secretario</h4>
                        <p>{ item.funcion }</p>
                        <div className='btn_agenda'>
                          <Link to="Agenda">Conoce la agenda del Secretario</Link>
                        </div>
                      </div>
                    </div>
                  </>
              ))
            }
          </div>
        </div>
        <div className='row'>
          <div className='section_map'>
            <div className='map_name'>
              <h3 className='title'>UBICACIÓN</h3>
              <hr className='hr-gob'/>
            </div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1730.313452547797!2d-98.78828606250923!3d20.123409041192936!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d10bff86d5f543%3A0x0ed9201e9bea4a7f!2sSecretar%C3%ADa+De+Seguridad+P%C3%BAbica+Del+Estado+De+Hidalgo!5e0!3m2!1ses!2smx!4v1544823743530"
                    width="100%" 
                    height="300" 
                    frameborder="0" 
                    style={{border:0, marginBottom:50}} 
                    allowfullscreen>
            </iframe>
          </div>
        </div>
        </div>
      </div>
    </>
  )
}

export default Inicio